import React from 'react'
import { Box } from '@mui/system'

type ActionState = 'add' | 'remove' | 'neutral'

interface ActionToggleProps {
  state: ActionState
  onChange?: () => void
  disabled?: boolean
  size?: number
  addColor?: string
  removeColor?: string
  addBorderColor?: string
  removeBorderColor?: string
  addBackgroundColor?: string
  removeBackgroundColor?: string
  neutralBorderColor?: string
  neutralBackgroundColor?: string
}

const ActionToggle: React.FC<ActionToggleProps> = ({
  state,
  onChange = () => {},
  disabled = false,
  size = 16,
  addColor = '#16A34A',
  removeColor = '#DC2626',
  addBorderColor = '#E6F0D7',
  removeBorderColor = '#FEE2E2',
  addBackgroundColor = '#F4F8ED',
  removeBackgroundColor = '#FEF2F2',
  neutralBorderColor = '#E5E7EB',
  neutralBackgroundColor = 'white'
}) => {
  const getStyles = () => {
    switch (state) {
      case 'add':
        return {
          backgroundColor: addBackgroundColor,
          borderColor: addBorderColor,
          color: addColor,
          icon: 'fa-solid fa-plus'
        }
      case 'remove':
        return {
          backgroundColor: removeBackgroundColor,
          borderColor: removeBorderColor,
          color: removeColor,
          icon: 'fa-solid fa-minus'
        }
      default:
        return {
          backgroundColor: neutralBackgroundColor,
          borderColor: neutralBorderColor,
          color: '#9CA3AF',
          icon: null
        }
    }
  }

  const styles = getStyles()

  return (
    <Box
      onClick={disabled ? undefined : onChange}
      sx={{
        width: size,
        height: size,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: disabled ? 'default' : 'pointer',
        position: 'relative',
        backgroundColor: styles.backgroundColor,
        border: `1px solid ${styles.borderColor}`,
        borderRadius: '4px',
        transition: 'all 0.2s ease-in-out',
        '&:hover': disabled ? {} : {
          opacity: 0.8
        }
      }}
    >
      {styles.icon && (
        <i 
          className={styles.icon} 
          style={{ 
            color: styles.color, 
            fontSize: `${size * 0.625}px`
          }} 
        />
      )}
    </Box>
  )
}

export default ActionToggle
